import { styled } from '@mui/material';
import { ChatSize } from '../../../enums/ChatAgentCreationStep';
import { getDimension } from '../../../helpers/agentHelper';

interface StyledChatWindowProps {
  chatSize?: ChatSize;
}

const StyledChatWindow = styled('div')<StyledChatWindowProps>`
  background-color: #fff;
  width: ${({ chatSize = ChatSize.SMALL }) => getDimension(chatSize).width};
  height: ${({ chatSize = ChatSize.SMALL }) => getDimension(chatSize).height};
  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 20px;
  display: flex;
  flex-direction: column;
`;

export default StyledChatWindow;
